/**
 * User: Rob Richard
 * Date: 9/9/14
 * Time: 11:39 AM
 */

'use strict';

const { getBuyerToken } = require('dibs-cookie-jar');
const FinancialAmount = require('bunsen/models/FinancialAmount');
const User = require('../../global/models/User');

const userHelpers = module.exports = {

    isUserAuthenticationRequired() {
        // auth when user logged out but email stored locally
        return !userHelpers.isLoggedIn() && !!userHelpers.getUserEmail();
    },
    getUserDisplayName() {
        const user = User.getCurrentUser();
        const profile = user && user.get('profile');
        return profile ? profile.getDisplayName() : '';
    },
    getUserEmail() {
        return User.getEmail() !== 'undefined' ? User.getEmail() : '';
    },
    logoutUser() {
        User.deleteStorage();
        User.logout(false);
    },
    isLoggedIn() {
        return User.loggedIn();
    },
    isUserCurrent(buyerId) {
        return Number(buyerId) === Number(userHelpers.getUserId());
    },
    getUserId() {
        return User.getUserId();
    },
    getUserToken() {
        return (getBuyerToken(document.cookie) || {}).userToken;
    },
    getBuyerDefaults() {
        return new User({
            apiType: 'user',
            profile: {
                currency: FinancialAmount.CURRENCY_USD
            },
            wallet: {
                paymentMethods: []
            }
        });
    }
};



// WEBPACK FOOTER //
// ./assets/js/checkout/helpers/checkout-user.es.js